import styled from "styled-components";
import { ThemeProps } from "../styles/theme";

export const Page = styled.div<ThemeProps>`
    min-height: 100vh;
    box-sizing: border-box;
    background-color: ${p => p.theme.primaryBackground};
    color: ${p => p.theme.primaryText};
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 24px 16px 64px;
`;

export const Content = styled.div`
    width: 100%;
    max-width: 800px;
    display: flex;
    flex-direction: column;
`;

export const PageTitle = styled.h1<ThemeProps>`
    font-size: 20px;
    font-weight: 700;
    margin: 0 0 24px;
    color: ${p => p.theme.primaryText};
`;

export const TableTitle = styled.div<ThemeProps>`
    font-size: 15px;
    font-weight: 600;
    color: ${p => p.theme.secondaryText};
    margin: 24px 0 8px;
`;

export const PrimaryButton = styled.button<ThemeProps>`
    align-self: flex-start;
    margin-top: 16px;
    padding: 8px 20px;
    font-size: 14px;
    font-weight: 600;
    background-color: ${p => p.theme.neutralButtonBackground};
    color: ${p => p.theme.neutralButtonForeground};
    border: ${p => p.theme.neutralButtonBorder} 1px solid;
    border-radius: 6px;
    cursor: pointer;

    &:hover {
        opacity: 0.85;
    }
`;

export const Message = styled.div<ThemeProps>`
    font-size: 15px;
    color: ${p => p.theme.secondaryText};
    padding: 40px 0;
    text-align: center;
`;
